import React, { Component } from "react";
import Button from "react-md/lib/Buttons";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import Helmet from "react-helmet";
import { TextField } from "react-md";
import Layout from "../layout";
import config from "../../data/SiteConfig";

class Reserv extends Component {
  render() {
    return (
      <Layout location={this.props.location} title='예약하기'>
        <div>
          <Helmet>
            <title>{`reserv | ${config.siteTitle}`}</title>
            <link rel='canonical' href={`${config.siteUrl}/reserv/`} />
          </Helmet>
          <div>
            <Card align='left'>
              <CardText>
                <p> * 모델링 파일 확인 </p>
                <img
                  src={`${config.siteUrl}/assets/car_model_img_file10.png`}
                  alt='drive'
                />
                <p> * 장소 선택 </p>
                <div>
                  <table align='center'>
                    <tr>
                      <td>
                        <TextField
                          id='floating-center-title'
                          label='장소를 검색하세요'
                          lineDirection='center'
                          placeholder='구,동,읍으로 검색'
                          className='md-cell md-cell--bottom'
                        />
                      </td>
                      <td width='80px'>
                        <Button
                          className='user-button'
                          icon='fa-search'
                          secondary
                          key='about'
                          iconClassName='fa fa-search'
                          href={`${config.siteUrl}/place`}
                        />
                      </td>
                    </tr>
                  </table>
                </div>
                <p className='md-title-1'> * 시간 선택 </p>
                장소를 먼저 선택해주세요
                <Button
                  className='user-button'
                  icon='fa-check-circle'
                  secondary
                  disabled
                  key='about'
                  iconClassName='fa fa-check-circle'
                  href={`${config.siteUrl}/reservsuccess`}
                />
                <p className='md-title-1'> 예약신청</p>
              </CardText>
            </Card>
          </div>
        </div>
      </Layout>
    );
  }
}

export default Reserv;
